import { useLocation } from 'react-router-dom';

export default function useActiveLink(path) {
  const { pathname } = useLocation();
  const isActive = pathname === path;

  return {
    active: isActive,
    isExternalLink: false,
  };
}
